/**
 * ENFAMI Product Page — lightbox, breadcrumb, accordéons, sticky, reveals
 */
(function () {
  'use strict';

  var main = document.querySelector('#MainContent');
  if (!main || main.dataset.template !== 'product') return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MOBILE = window.matchMedia('(max-width: 989px)').matches;

  function getProductData() {
    var el = document.getElementById('ep-product-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /* ── Barre progression scroll ── */
  function initScrollProgress() {
    var bar = document.getElementById('ep-scroll-progress');
    if (!bar) return;

    function update() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var pct = max > 0 ? (window.scrollY / max) * 100 : 0;
      bar.style.width = pct + '%';
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ── Fil d'Ariane + cashback ── */
  function initProductHeader() {
    var details = document.querySelector('.product-details');
    if (!details || details.querySelector('.ep-product-top')) return;

    var data = getProductData();
    var i18n = (data && data.i18n) || {};
    var top = document.createElement('div');
    top.className = 'ep-product-top';

    var breadcrumb = document.createElement('nav');
    breadcrumb.className = 'ep-breadcrumb';
    breadcrumb.setAttribute('aria-label', 'Breadcrumb');
    breadcrumb.innerHTML =
      '<a href="/">' + (i18n.home || 'Home') + '</a>' +
      '<span class="ep-breadcrumb__sep">&gt;</span>' +
      '<a href="' + (data && data.collectionUrl ? data.collectionUrl : '/collections/all') + '">' +
      (data && data.collection ? data.collection : 'Jerseys') +
      '</a>' +
      '<span class="ep-breadcrumb__sep">&gt;</span>' +
      '<span class="ep-breadcrumb__current">' + (data && data.title ? data.title : 'Product') + '</span>';

    top.appendChild(breadcrumb);

    var first = details.firstElementChild;
    if (first) details.insertBefore(top, first);
    else details.appendChild(top);
  }

  function initCashback() {
    /* Désactivé — pas de cashback sur la PDP */
    document.querySelectorAll('.ep-cashback').forEach(function (el) {
      el.remove();
    });
  }

  function initGalleryFix() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    gallery.classList.remove('media-gallery--large-first-image');

    var isWide = window.matchMedia('(min-width: 990px)').matches;
    var slideshow = gallery.querySelector('slideshow-component');
    var grid = gallery.querySelector('.media-gallery__grid');
    var cells = gallery.querySelectorAll('.media-gallery__grid > .product-media-container');
    var count = cells.length;

    gallery.classList.toggle('ep-gallery--single', count === 1);
    gallery.classList.toggle('ep-gallery--duo', count === 2);

    /* Toujours afficher la grille (source réelle des images) */
    if (slideshow) slideshow.style.setProperty('display', 'none', 'important');

    if (grid) {
      grid.style.setProperty('display', 'grid', 'important');
      if (isWide && count > 1) {
        grid.style.setProperty('grid-template-columns', 'repeat(2, minmax(0, 1fr))', 'important');
      } else if (!isWide && count > 1 && window.matchMedia('(min-width: 750px)').matches) {
        grid.style.setProperty('grid-template-columns', 'repeat(2, minmax(0, 1fr))', 'important');
      } else {
        grid.style.setProperty('grid-template-columns', '1fr', 'important');
      }
      grid.style.setProperty('gap', '12px', 'important');
    }

    cells.forEach(function (cell) {
      cell.classList.remove('constrain-height');
      cell.style.setProperty('opacity', '1', 'important');
      cell.style.setProperty('visibility', 'visible', 'important');
      if (count === 1 || !window.matchMedia('(min-width: 750px)').matches) {
        cell.style.setProperty('grid-column', '1 / -1', 'important');
      } else {
        cell.style.setProperty('grid-column', 'span 1', 'important');
      }
      cell.style.removeProperty('height');
    });

    var mediaCol = document.querySelector('.product-information__media');
    if (mediaCol) {
      mediaCol.style.setProperty('width', '100%', 'important');
      mediaCol.style.setProperty('min-width', '0', 'important');
      mediaCol.style.setProperty('max-width', '100%', 'important');
      mediaCol.style.setProperty('opacity', '1', 'important');
      mediaCol.style.setProperty('visibility', 'visible', 'important');
      mediaCol.style.setProperty('grid-column', isWide ? '1' : '1 / -1', 'important');
    }

    var gridEl = document.querySelector('.product-information__grid');
    if (gridEl) {
      gridEl.style.setProperty('display', 'grid', 'important');
      gridEl.style.setProperty(
        'grid-template-columns',
        isWide ? 'minmax(0, 1.05fr) minmax(0, 0.95fr)' : '1fr',
        'important'
      );
    }

    var details = document.querySelector('.product-details');
    if (details) {
      details.style.setProperty('grid-column', isWide ? '2' : '1 / -1', 'important');
      details.style.removeProperty('max-height');
      details.style.removeProperty('height');
      details.style.removeProperty('overflow-y');
      details.style.removeProperty('overflow');
    }

    gallery.querySelectorAll('img.product-media__image, .media-gallery__grid img').forEach(function (img) {
      img.style.setProperty('opacity', '1', 'important');
      img.style.setProperty('visibility', 'visible', 'important');
      img.classList.add('ef-img-ready');
      if (img.loading === 'lazy' && !img.complete) img.loading = 'eager';
    });

    var section = document.querySelector('.shopify-section:has(.product-information)');
    if (section) {
      section.classList.add('is-revealed');
      section.classList.remove('is-pending-reveal');
      section.removeAttribute('data-reveal');
      section.style.setProperty('opacity', '1', 'important');
      section.style.setProperty('transform', 'none', 'important');
    }

    syncDetailsToGalleryHeight();
  }

  function syncDetailsToGalleryHeight() {
    var details = document.querySelector('.product-details');
    if (!details) return;
    /* Plus de max-height : titre / prix toujours visibles, scroll page normale */
    details.style.removeProperty('max-height');
    details.style.removeProperty('height');
    details.style.removeProperty('overflow-y');
    details.style.removeProperty('overflow');
    details.scrollTop = 0;
  }

  function bindDetailsWheel() {
    /* Désactivé — le scroll interne coupait le haut (prix / titre) */
  }

  function initNewDropBadge() {
    var first = document.querySelector('.product-media-container');
    if (!first || first.querySelector('.ep-new-drop')) return;

    var badge = document.createElement('span');
    badge.className = 'ep-new-drop';
    badge.textContent = 'NEW DROP';
    first.appendChild(badge);
  }

  function initVariantPickerLayout() {
    var picker = document.querySelector('variant-picker');
    if (!picker) return;

    var isKids = picker.getAttribute('data-kids-product') === 'true' ||
      picker.classList.contains('variant-picker--kids');
    var sizeWords = ['size', 'taille', 'größe', 'talla', 'taglia', 'pointure'];
    var flocageWords = ['flocage', 'printing', 'customization', 'personnalisation'];
    var sizeValueRe = /^(xs|s|m|l|xl|xxl|2xl|3xl|4xl|5xl|6xl|1[6-8]|2[0-8])$/i;
    var kidsAgeRe = /^\d{2}-\d{2}\s*years?/i;
    var shirtSvg =
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">' +
      '<path d="M16 3l4 3v4l-4 2v9H8v-9l-4-2V6l4-3 2 2h4l2-2z"/></svg>';
    var personSvg =
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">' +
      '<circle cx="12" cy="8" r="3.25"/><path d="M5.5 20c1.6-3.4 4-5 6.5-5s4.9 1.6 6.5 5"/></svg>';
    var rulerSvg =
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">' +
      '<path d="M4 8h16M6 8v3M10 8v2M14 8v3M18 8v2"/></svg>';
    var finderIcon = isKids ? personSvg : shirtSvg;
    var kidsLabelMap = {
      '16': '02-03 ans',
      '18': '03-04 ans',
      '20': '04-05 ans',
      '22': '06-07 ans',
      '24': '08-09 ans',
      '26': '10-11 ans',
      '28': '12-13 ans'
    };
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('fr') !== 0) {
      kidsLabelMap = {
        '16': '02-03 Years',
        '18': '03-04 Years',
        '20': '04-05 Years',
        '22': '06-07 Years',
        '24': '08-09 Years',
        '26': '10-11 Years',
        '28': '12-13 Years'
      };
    }

    function applyKidsSizeLabels(fs) {
      fs.querySelectorAll('.variant-option__button-label').forEach(function (label) {
        var input = label.querySelector('input');
        if (!input) return;
        var val = String(input.value || '').trim();
        var mapped = kidsLabelMap[val];
        if (!mapped) return;
        var text = label.querySelector('.variant-option__button-label__text');
        if (text) {
          text.textContent = mapped;
          text.setAttribute('data-kids-label', 'true');
          text.setAttribute('data-size-value', val);
        }
      });
    }

    function isSizeFieldset(fs) {
      var leg = fs.querySelector('legend');
      var name = ((leg && leg.textContent) || '').trim().toLowerCase();
      if (sizeWords.some(function (w) { return name.indexOf(w) !== -1; })) return true;

      var labels = fs.querySelectorAll('.variant-option__button-label');
      if (labels.length < 3) return false;
      var sizeLike = 0;
      labels.forEach(function (label) {
        var t = (label.textContent || '').trim().toLowerCase().replace(/\s+/g, '');
        var raw = (label.textContent || '').trim();
        if (sizeValueRe.test(t) || kidsAgeRe.test(raw)) sizeLike += 1;
        var input = label.querySelector('input');
        if (input && /^(16|18|20|22|24|26|28)$/.test(String(input.value || '').trim())) sizeLike += 1;
      });
      return sizeLike >= 3;
    }

    picker.querySelectorAll('fieldset').forEach(function (fs) {
      var leg = fs.querySelector('legend');
      if (!leg) return;

      var name = (leg.textContent || '').trim().toLowerCase();

      if (flocageWords.some(function (w) { return name.indexOf(w) !== -1; })) {
        fs.classList.add('ep-variant--flocage');
        fs.classList.remove('ep-variant--size', 'ep-variant--category');
        return;
      }

      if (isSizeFieldset(fs)) {
        fs.classList.add('ep-variant--size');
        fs.classList.remove('ep-variant--category', 'ep-variant--flocage');
        leg.classList.add('ep-variant-legend');
        applyKidsSizeLabels(fs);

        var links = document.querySelector('.efc__size-links');
        if (links && !fs.querySelector('.ep-size-tools')) {
          var tools = document.createElement('div');
          tools.className = 'ep-size-tools';
          while (links.firstChild) tools.appendChild(links.firstChild);
          links.classList.add('efc__size-links--detached');
          leg.appendChild(tools);

          tools.querySelectorAll('[data-efc-open-finder]').forEach(function (btn) {
            btn.type = 'button';
            if (!btn.querySelector('svg')) btn.insertAdjacentHTML('afterbegin', finderIcon);
            if (btn.dataset.efcBound === '1') return;
            btn.dataset.efcBound = '1';
            btn.addEventListener(
              'click',
              function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (window.EnfamiSizeModals) window.EnfamiSizeModals.openFinder();
              },
              true
            );
          });
          tools.querySelectorAll('[data-efc-open-guide]').forEach(function (btn) {
            btn.type = 'button';
            if (!btn.querySelector('svg')) btn.insertAdjacentHTML('afterbegin', rulerSvg);
            if (btn.dataset.efcBound === '1') return;
            btn.dataset.efcBound = '1';
            btn.addEventListener(
              'click',
              function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (window.EnfamiSizeModals) window.EnfamiSizeModals.openGuide();
              },
              true
            );
          });
        }
      } else {
        fs.classList.add('ep-variant--category');
        fs.classList.remove('ep-variant--size', 'ep-variant--flocage');
      }

      fs.querySelectorAll('.variant-option__button-label').forEach(function (label) {
        label.style.removeProperty('width');
        label.style.removeProperty('min-width');
        label.style.removeProperty('max-width');
        label.style.removeProperty('flex');
        label.style.removeProperty('transform');
        label.style.removeProperty('display');
        label.style.removeProperty('opacity');
      });
    });

    if (picker.dataset.epLayoutObserver !== 'true') {
      picker.dataset.epLayoutObserver = 'true';
      var timer = null;
      var mo = new MutationObserver(function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(initVariantPickerLayout, 40);
      });
      mo.observe(picker, { childList: true, subtree: true });
    }
  }

  /* ── Bloc livraison + paiement ── */
  function initDeliveryBlock() {
    var details = document.querySelector('.product-details');
    if (!details || details.querySelector('.ep-delivery-block')) return;

    var data = getProductData();
    var i18n = (data && data.i18n) || {};
    var trust = details.querySelector('.ep-product-trust');
    var block = document.createElement('div');
    block.className = 'ep-delivery-block';
    block.innerHTML =
      '<div class="ep-delivery-block__item">' +
        '<span class="ep-delivery-block__icon">🚚</span>' +
        '<div><strong>' + (i18n.ship || 'Ships in 24–48h') + '</strong><span>' + (i18n.ship_sub || 'Tracked shipping') + '</span></div>' +
      '</div>' +
      '<div class="ep-delivery-block__item">' +
        '<span class="ep-delivery-block__icon">📸</span>' +
        '<div><strong>' + (i18n.photo || 'Photo before shipping') + '</strong><span>' + (i18n.photo_sub || 'Email + WhatsApp') + '</span></div>' +
      '</div>' +
      '<div class="ep-delivery-block__item">' +
        '<span class="ep-delivery-block__icon">🔒</span>' +
        '<div><strong>' + (i18n.pay || 'Secure payment') + '</strong><span>' + (i18n.pay_sub || 'Shop Pay · Apple Pay · Visa') + '</span></div>' +
      '</div>';

    if (trust) trust.insertAdjacentElement('afterend', block);
    else details.appendChild(block);
  }

  function initWhyEnfami() {
    var productSection = document.querySelector('.product-information');
    if (!productSection || document.querySelector('.ep-why-enfami')) return;

    var strip = document.createElement('section');
    strip.className = 'ep-why-enfami';
    strip.setAttribute('data-reveal', '');
    strip.innerHTML =
      '<div class="ep-why-enfami__inner">' +
        '<div class="ep-why-enfami__item" data-stagger-child><span>🏆</span><strong>Qualité premium</strong><p>Maillots haute fidélité, finitions soignées</p></div>' +
        '<div class="ep-why-enfami__item" data-stagger-child><span>✂️</span><strong>Flocage pro</strong><p>Nom, numéro et patchs inclus</p></div>' +
        '<div class="ep-why-enfami__item" data-stagger-child><span>🌍</span><strong>Livraison mondiale</strong><p>Canada, USA et 50+ pays</p></div>' +
        '<div class="ep-why-enfami__item" data-stagger-child><span>💬</span><strong>Support réactif</strong><p>WhatsApp & Instagram @enfami_soccer</p></div>' +
      '</div>';

    productSection.insertAdjacentElement('afterend', strip);
  }

  /* ── Description en accordéon ── */
  function initDescriptionAccordion() {
    /* Description produit masquée — non désirée sur la PDP */
    document.querySelectorAll('.product-details .rte, .product-details .ep-accordion').forEach(function (el) {
      el.remove();
    });
  }

  /* ── Compteur galerie + bouton zoom ── */
  function initGalleryUI() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery || gallery.querySelector('.ep-gallery-ui')) return;

    var mediaItems = gallery.querySelectorAll('.product-media-container, slideshow-slide');
    var count = mediaItems.length;
    if (count === 0) return;

    var ui = document.createElement('div');
    ui.className = 'ep-gallery-ui';
    ui.innerHTML =
      '<span class="ep-gallery-ui__counter" data-ep-gallery-counter>1 / ' + count + '</span>' +
      '<button type="button" class="ep-gallery-ui__zoom" data-ep-gallery-zoom aria-label="Agrandir">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35M11 8v6M8 11h6"/></svg>' +
      '</button>';

    gallery.style.position = 'relative';
    gallery.appendChild(ui);

    var counter = ui.querySelector('[data-ep-gallery-counter]');

    function updateCounter() {
      var active = gallery.querySelector(
        '.product-media-container.is-active, slideshow-slide[aria-hidden="false"], [aria-current="true"]'
      );
      if (!active) return;
      var idx = Array.prototype.indexOf.call(mediaItems, active);
      if (idx >= 0) counter.textContent = idx + 1 + ' / ' + count;
    }

    gallery.addEventListener('slideshow:select', updateCounter);
    gallery.addEventListener('click', function (e) {
      if (e.target.closest('.slideshow-controls, button, a')) return;
      setTimeout(updateCounter, 50);
    });

    ui.querySelector('[data-ep-gallery-zoom]').addEventListener('click', function () {
      openLightbox(getCurrentGalleryIndex(gallery, mediaItems));
    });

    mediaItems.forEach(function (slide, i) {
      slide.addEventListener('dblclick', function () { openLightbox(i); });
      if (!MOBILE) slide.style.cursor = 'zoom-in';
    });
  }

  function getCurrentGalleryIndex(gallery, mediaItems) {
    var active = gallery.querySelector(
      '.product-media-container.is-active, slideshow-slide[aria-hidden="false"], [aria-current="true"]'
    );
    var idx = active ? Array.prototype.indexOf.call(mediaItems, active) : 0;
    return idx >= 0 ? idx : 0;
  }

  /* ── Lightbox plein écran ── */
  var lightboxIndex = 0;
  var lightboxMedia = [];

  function initLightbox() {
    var data = getProductData();
    lightboxMedia = (data && data.media && data.media.length) ? data.media : [];

    if (!lightboxMedia.length) {
      document.querySelectorAll('.product-media-container img, media-gallery img').forEach(function (img) {
        if (img.src && lightboxMedia.length < 12) {
          lightboxMedia.push({ src: img.src.replace(/width=\d+/, 'width=2000'), thumb: img.src, alt: img.alt || '' });
        }
      });
    }

    var lb = document.getElementById('ep-lightbox');
    if (!lb) return;

    lb.querySelectorAll('[data-ep-lightbox-close]').forEach(function (btn) {
      btn.addEventListener('click', closeLightbox);
    });
    lb.querySelector('[data-ep-lightbox-prev]').addEventListener('click', function () { goLightbox(-1); });
    lb.querySelector('[data-ep-lightbox-next]').addEventListener('click', function () { goLightbox(1); });

    document.addEventListener('keydown', function (e) {
      if (lb.getAttribute('aria-hidden') === 'true') return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') goLightbox(-1);
      if (e.key === 'ArrowRight') goLightbox(1);
    });

    var thumbs = lb.querySelector('[data-ep-lightbox-thumbs]');
    lightboxMedia.forEach(function (m, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ep-lightbox__thumb';
      btn.innerHTML = '<img src="' + m.thumb + '" alt="" width="56" height="56">';
      btn.addEventListener('click', function () { showLightboxSlide(i); });
      thumbs.appendChild(btn);
    });
  }

  function openLightbox(index) {
    if (!lightboxMedia.length) return;
    var lb = document.getElementById('ep-lightbox');
    if (!lb) return;
    lb.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ep-lightbox-open');
    showLightboxSlide(index || 0);
  }

  function closeLightbox() {
    var lb = document.getElementById('ep-lightbox');
    if (!lb) return;
    lb.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ep-lightbox-open');
  }

  function goLightbox(dir) {
    showLightboxSlide((lightboxIndex + dir + lightboxMedia.length) % lightboxMedia.length);
  }

  function showLightboxSlide(index) {
    lightboxIndex = index;
    var lb = document.getElementById('ep-lightbox');
    if (!lb || !lightboxMedia[index]) return;

    var img = lb.querySelector('.ep-lightbox__img');
    var item = lightboxMedia[index];
    img.src = item.src;
    img.alt = item.alt || '';

    lb.querySelector('[data-ep-lightbox-counter]').textContent = index + 1 + ' / ' + lightboxMedia.length;

    lb.querySelectorAll('.ep-lightbox__thumb').forEach(function (t, i) {
      t.classList.toggle('is-active', i === index);
    });

    if (!REDUCED) {
      img.style.opacity = '0';
      img.style.transform = 'scale(0.96)';
      requestAnimationFrame(function () {
        img.style.transition = 'opacity 0.35s ease, transform 0.45s cubic-bezier(0.22,1,0.36,1)';
        img.style.opacity = '1';
        img.style.transform = 'scale(1)';
      });
    }
  }

  window.openLightbox = openLightbox;

  /* ── Sticky bar mobile améliorée ── */
  function initStickyEnhance() {
    document.body.classList.add('ep-has-sticky-atc');
    var sticky = document.querySelector('sticky-add-to-cart');
    if (!sticky) return;

    var buyBtn = document.querySelector('.product-form__submit, [name="add"]');
    if (!buyBtn) return;

    var observer = new IntersectionObserver(
      function (entries) {
        sticky.classList.toggle('ep-sticky-visible', !entries[0].isIntersecting);
      },
      { threshold: 0, rootMargin: '0px 0px -80px 0px' }
    );
    observer.observe(buyBtn);
  }

  /* ── Reveal sections bas de page ── */
  function scrubRecommendationChrome() {
    document.querySelectorAll('product-recommendations').forEach(function (root) {
      root.querySelectorAll('quick-add-component, .quick-add, .product-badges, .price-discount-badge').forEach(function (el) {
        el.remove();
      });
    });
  }

  function initSectionReveal() {
    if (REDUCED || !('IntersectionObserver' in window)) return;

    document.querySelectorAll('.product-recommendations, .efaq, .ep-why-enfami').forEach(function (el) {
      if (!el.hasAttribute('data-reveal')) el.setAttribute('data-reveal', '');
    });

    scrubRecommendationChrome();
    var recoRoots = document.querySelectorAll('product-recommendations');
    if (recoRoots.length && 'MutationObserver' in window) {
      var recoMo = new MutationObserver(function () {
        scrubRecommendationChrome();
      });
      recoRoots.forEach(function (root) {
        recoMo.observe(root, { childList: true, subtree: true });
      });
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            scrubRecommendationChrome();
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -5% 0px' }
    );

    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      io.observe(el);
    });
  }

  /* ── Swipe hint mobile galerie ── */
  function initMobileGalleryHint() {
    if (!MOBILE) return;
    var gallery = document.querySelector('media-gallery');
    if (!gallery || gallery.querySelector('.ep-gallery-hint')) return;

    var hint = document.createElement('div');
    hint.className = 'ep-gallery-hint';
    hint.textContent = '← Glisser pour voir plus →';
    gallery.appendChild(hint);
    setTimeout(function () { hint.classList.add('is-hidden'); }, 4000);
  }

  function initTitleSplit() {
    if (REDUCED) return;
    var h1 = document.querySelector('.product-details h1');
    if (!h1 || h1.dataset.splitDone) return;
    h1.dataset.splitDone = 'true';
    var text = h1.textContent.trim();
    h1.textContent = '';
    h1.setAttribute('aria-label', text);
    var ci = 0;
    text.split(/\s+/).forEach(function (word, wi, arr) {
      word.split('').forEach(function (ch) {
        var s = document.createElement('span');
        s.className = 'split-char';
        s.textContent = ch;
        s.style.animationDelay = ci * 0.025 + 's';
        s.setAttribute('aria-hidden', 'true');
        h1.appendChild(s);
        ci++;
      });
      if (wi < arr.length - 1) h1.appendChild(document.createTextNode(' '));
    });
  }

  function boot() {
    initGalleryFix();
    setTimeout(initGalleryFix, 150);
    setTimeout(initGalleryFix, 900);
    initProductHeader();
    initCashback();
    initVariantPickerLayout();
    initNewDropBadge();
    initDescriptionAccordion();
    initLightbox();
    initStickyEnhance();
    initSectionReveal();
    window.addEventListener('resize', syncDetailsToGalleryHeight);
    window.addEventListener('load', syncDetailsToGalleryHeight);
    window.addEventListener('resize', function () {
      initGalleryFix();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
